/**
 * Shared booking-status helpers for the chat card components
 * (BookingListCards, UpdateBookingCards, CancelBookingCards).
 */

/**
 * True when the booking is happening RIGHT NOW: not cancelled and
 * start_time <= now <= end_time.
 *
 * Computed at render time (not sent by the backend) so a card in older
 * chat history never shows a stale "Ongoing" badge after the booking ends.
 *
 * @param {Object} booking - booking from raw_output.bookings; start_time /
 *   end_time are ISO strings with offset (e.g. "2026-07-11T18:30:00-06:00")
 * @returns {boolean}
 */
export function isOngoingBooking(booking) {
  if (!booking) return false;
  if (booking.status?.toLowerCase() === 'cancelled') return false;
  if (!booking.start_time || !booking.end_time) return false;

  const start = new Date(booking.start_time).getTime();
  const end = new Date(booking.end_time).getTime();
  if (Number.isNaN(start) || Number.isNaN(end)) return false;

  const now = Date.now();
  return start <= now && now <= end;
}
